import { useI18n } from './i18n';
import React, { FC } from 'react';
import { EditEventOverlay_event$data } from '../apps/TenantApp/screens/Event/components/__generated__/EditEventOverlay_event.graphql';
import { notEmpty } from './NotEmptyFilter';

export type EventTimeType = {
  start?: EditEventOverlay_event$data['start'];
  end?: EditEventOverlay_event$data['end'];
  timezone?: string;
  allDay?: boolean;
  schedulingConfig: EditEventOverlay_event$data['schedulingConfig'];
  pickedSchedulingOptionId?: string;
  resetScheduleVotes?: boolean;
  scheduleLater?: boolean;
};

export const useEventTimeInput = ({
  start,
  end,
  timezone,
  allDay,
  schedulingConfig,
  pickedSchedulingOptionId,
  resetScheduleVotes,
  scheduleLater,
}: EventTimeType) => {
  const { format } = useI18n();

  const currentManualTime =
    start && end
      ? {
          startDate: start.date,
          startTime: start.time,
          endDate: end.date,
          endTime: end.time,
          timezone,
          allDay,
        }
      : undefined;

  const currentSchedulingConfig = schedulingConfig
    ? {
        durationInMinutes: schedulingConfig.durationInMinutes,
        proposedStartTimes: schedulingConfig.proposedTimes.map((pt) => {
          const start = pt.start ? new Date(pt.start.utcDatetime) : '';
          return {
            id: pt.id,
            startDate: start && format(start, 'yyyy-MM-dd'),
            startTime: start && format(start, 'HH:mm'),
            delete: false,
            votes: pt.votes.edges.map((edge) => edge.node).filter(notEmpty),
          };
        }),
        timezone: schedulingConfig.timezone,
      }
    : undefined;

  return {
    manualTime: currentManualTime,
    schedulingConfig: currentSchedulingConfig,
    pickedSchedulingOptionId,
    resetScheduleVotes,
    scheduleLater,
  };
};

export const DisplayDate: FC<{ date: string }> = ({ date }) => {
  const { format } = useI18n();
  const timeParts = date.split('-');
  const year = (timeParts && parseInt(timeParts[0])) || 0,
    month = (timeParts && parseInt(timeParts[1])) || 0,
    day = (timeParts && parseInt(timeParts[2])) || 0;

  return (
    <>
      {format(
        // minus 1 for month as January === 0
        new Date(year, month - 1, day),
        'PPPP',
      )}
    </>
  );
};

export function isPastEvent(
  eventHasStart: boolean,
  eventEndDate: string | undefined,
  eventEndTime: string | undefined,
): boolean {
  if (!eventHasStart || !eventEndDate || !eventEndTime) {
    return false;
  }

  const endDate = new Date(`${eventEndDate}T${eventEndTime}`);
  const today = new Date();

  return endDate < today;
}
